module.exports = __webpack_public_path__ + "img/spiral-details13.929f1a02.png";